import { SignTypesChoices } from './sign-type';

export enum MaterialType {
  DUOPROP_4MM = 'Duoprop 4mm',
  X_PRINT_8MM = 'X-print 8mm',
  DIBOND_3MM = 'DIBOND 3mm',
  OTHER = 'Andere',
}

export const MaterialOptions: Record<string, MaterialType[]> = {
  [SignTypesChoices.INPRESS.value]: [
    MaterialType.DUOPROP_4MM,
    MaterialType.X_PRINT_8MM,
    MaterialType.DIBOND_3MM,
    MaterialType.OTHER,
  ],
  [SignTypesChoices.STICKER.value]: [
    MaterialType.DUOPROP_4MM,
    MaterialType.OTHER,
  ],
};
